import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (!sessionId) {
      setError('No session ID found');
      setLoading(false);
      return;
    }

    // Here you could verify the session with your backend
    // For now, we'll just show success
    setLoading(false);
  }, [searchParams]);

  const handleContinue = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div className="payment-success-container">
        <div className="payment-success-content">
          <div className="loading-spinner"></div>
          <h2>Processing your payment...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-success-container">
        <div className="payment-success-content error">
          <div className="error-icon">❌</div>
          <h2>Payment Error</h2>
          <p>{error}</p>
          <button onClick={handleContinue} className="continue-button">
            Return to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container">
      <div className="payment-success-content">
        <div className="success-icon">✅</div>
        <h2>Payment Successful!</h2>
        <p>Thank you for subscribing. Your account has been upgraded and you now have access to all premium features.</p>
        
        <div className="success-details">
          <h3>What's Next?</h3>
          <ul>
            <li>Create unlimited AI agents</li>
            <li>Access advanced analytics</li>
            <li>Get priority support</li>
            <li>Upload more files and context</li>
          </ul>
        </div>

        <button onClick={handleContinue} className="continue-button">
          Start Building Your Agents
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
